import { createEvent, createStore } from 'effector';
import type { Vector3Like } from '../scene/sceneConfig';

export type SplatTransformState = {
  position: Vector3Like;
  rotation: Vector3Like;
  scale: Vector3Like;
};

const DEFAULT_TRANSFORM: SplatTransformState = {
  position: { x: 0, y: 0, z: 0 },
  rotation: { x: 0, y: 0, z: 0 },
  scale: { x: 1, y: 1, z: 1 },
};

export const initSplatTransform = createEvent<SplatTransformState>();
export const updateSplatTransform = createEvent<Partial<SplatTransformState>>();

export const $splatTransform = createStore<SplatTransformState>(DEFAULT_TRANSFORM)
  .on(initSplatTransform, (_, t) => t)
  .on(updateSplatTransform, (state, patch) => ({
    position: patch.position ?? state.position,
    rotation: patch.rotation ?? state.rotation,
    scale: patch.scale ?? state.scale,
  }));

export const $splatTransformInitial = createStore<SplatTransformState>(DEFAULT_TRANSFORM)
  .on(initSplatTransform, (_, t) => t);

export const setSplatDebugVisible = createEvent<boolean>();
export const $splatDebugVisible = createStore(true)
  .on(setSplatDebugVisible, (_, v) => v);
